/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoteAliases {
  ACTION_ADD = 'action-add',
  ACTION_PRINT = 'action-print',
  BUTTON_CANCELAR = 'button-cancelar',
  BUTTON_CONFIRM_ADESAO = 'button-confirm-adesao',
  BUTTON_CONFIRMAR = 'button-confirmar',
  BUTTON_ENVIAR_ARQUIVOS = 'button-enviar-arquivos',
  BUTTON_NAO = 'button-nao',
  BUTTON_SIM = 'button-sim',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DECK_0 = 'deck-0',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_BENEFICIARIO_LOTE = 'fetch-beneficiario-lote',
  FIELD_0 = 'field-0',
  FIELD_ADESAO = 'field-adesao',
  FIELD_DIALOG = 'field-dialog',
  FIELD_MENSAGEM_EXCLUIR = 'field-mensagem excluir',
  FIELD_NAME = 'field-name',
  FIELD_OP = 'field-op',
  FIELD_SOLIC = 'field-solic',
  FILE_UPLOADER_MODAL = 'file-uploader-modal',
  FORM_ADESAO = 'form-adesao',
  HPMS_CUSTOM_CARD_BENEF_LOTE = 'hpms-custom-card-benef-lote',
  HPMS_CUSTOM_DIALOG = 'hpms-custom-dialog',
  HPMS_CUSTOM_DIALOG_EXCLUIR = 'hpms-custom-dialog-excluir',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_3 = 'layout-3',
  LOTE_ATTACHMENTS_LIST = 'lote-attachments-list',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_ADESAO = 'panel-adesao',
  PANEL_ANEXOS = 'panel-anexos',
  PANEL_ATTACH = 'panel-attach',
  PANEL_BUTTON_ANEXOS = 'panel-button-anexos',
  PANEL_CARD = 'panel-card',
  PANEL_CONFIRM = 'panel-confirm',
  PANEL_CONTROL_CARD = 'panel-control-card',
  PANEL_FILE_UPLOADER = 'panel-file-uploader',
  PANEL_LIST = 'panel-list',
  PANEL_LOTE = 'panel-lote',
  PANEL_TAB_BENEFS = 'panel-tab-benefs',
  STAMP_SITUACAO_LOTE = 'stamp-situacao-lote',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TAB_WITH_CONTENT_BENEFS_LOTE = 'tab-with-content-benefs-lote',
  TEXT_0 = 'text-0',
  TEXT_DIALOG = 'text-dialog',
  TEXT_MOTIVO = 'text-motivo',
  TEXT_NAME = 'text-name',
  TEXT_OP = 'text-op',
  TEXT_SOLIC = 'text-solic',
}
export { LoteAliases };
